export default [
  {latitude: 41.90, longitude: 12.45 , name: 'Vatican City'},
  {latitude: 43.73, longitude: 7.41 , name: 'Monaco'},
  {latitude: -0.52, longitude: 166.93 , name: 'Nauru'},
  {latitude: -8.51, longitude: 179.21 , name: 'Tuvalu'},
  {latitude: 43.93, longitude: 12.46 , name: 'San Marino'},
  {latitude: 47.14, longitude: 9.52 , name: 'Liechtenstein'},
  {latitude: 7.11, longitude: 171.06 , name: 'Marshall Islands'},
  {latitude: 17.3, longitude: -62.73 , name: 'Saint Kitts and Nevis'},
  {latitude: 3.2, longitude: 73.22 , name: 'Maldives'},
  {latitude: 35.88, longitude: 14.5 , name: 'Malta'},
  {latitude: 12.05, longitude: -61.75 , name: 'Grenada'},
  {latitude: 13.16, longitude: -61.23 , name: 'Saint Vincent and the Grenadines'},
  {latitude: 13.16, longitude: -59.55 , name: 'Barbados'},
  {latitude: 17.11, longitude: -61.85 , name: 'Antigua and Barbuda'},
  {latitude: -4.61, longitude: 55.45 , name: 'Seychelles'},
  {latitude: 7.35, longitude: 134.46 , name: 'Palau'},
  {latitude: 42.5, longitude: 1.51 , name: 'Andorra'},
  {latitude: 14.01, longitude: -60.98 , name: 'Saint Lucia'},
  {latitude: 6.91, longitude: 158.18 , name: 'Federated States of Micronesia'},
  {latitude: 1.3, longitude: 103.8 , name: 'Singapore'},
  {latitude: 1.46, longitude: 173.03 , name: 'Kiribati'},
  {latitude: -21.13, longitude: -175.2 , name: 'Tonga'},
  {latitude: 15.3, longitude: -61.38 , name: 'Dominica'},
  {latitude: -20.2, longitude: 57.5 , name: 'Mauritius'},
  {latitude: 26.02, longitude: 50.55 , name: 'Bahrain'},
  {latitude: 0.33, longitude: 6.73 , name: 'S?o Tom? and Pr?ncipe'},
]